<template>
  <div class="login-container">
    <div class="login-box">
      <div class="logo-section">
        <h1 class="app-title">✨ PixelMuse ✨</h1>
        <p class="app-subtitle">欢迎来到我们的世界</p>
      </div>

      <!-- 登录表单 -->
      <div v-if="isLogin" class="form-section">
        <h2 class="form-title">用户登录</h2>
        <form @submit.prevent="handleLogin">
          <div class="input-group">
            <label>手机号</label>
            <input
              type="tel"
              v-model="loginForm.phone"
              placeholder="请输入手机号"
              maxlength="11"
              required
            />
          </div>

          <div class="input-group">
            <label>密码</label>
            <div class="code-input-wrapper">
              <input
                type="password"
                v-model="loginForm.password"
                placeholder="请输入密码"
                minlength="6"
                required
              />
            </div>
          </div>

          <button type="submit" class="submit-btn" :loading="loginLoading" :disabled="loginLoading">
            {{ loginLoading ? '登录中...' : '登录' }}
          </button>
        </form>

        <div class="switch-form">
          <span>还没有账号？</span>
          <a href="#" @click.prevent="toggleForm">立即注册</a>
          <br>
          <span>注册成功送500积分</span>
        </div>
      </div>

      <!-- 注册表单 -->
      <div v-else class="form-section">
        <h2 class="form-title">用户注册</h2>
        <form @submit.prevent="handleRegister">
          <div class="input-group">
            <label>手机号</label>
            <input
              type="tel"
              v-model="registerForm.phone"
              placeholder="请输入手机号"
              maxlength="11"
              required
            />
          </div>

          <div class="input-group">
            <label>验证码</label>
            <div class="code-input-wrapper">
              <input
                type="text"
                v-model="registerForm.code"
                placeholder="请输入验证码"
                maxlength="6"
                required
              />
              <button
                type="button"
                class="send-code-btn"
                :disabled="countdown > 0"
                @click="sendCode('register')"
              >
                {{ countdown > 0 ? `${countdown}s` : '获取验证码' }}
              </button>
            </div>
          </div>

          <div class="input-group">
            <label>设置密码</label>
            <input
              type="password"
              v-model="registerForm.password"
              placeholder="请设置密码（至少6位）"
              minlength="6"
              required
            />
          </div>

          <div class="input-group">
            <label>确认密码</label>
            <input
              type="password"
              v-model="registerForm.confirmPassword"
              placeholder="请再次输入密码"
              minlength="6"
              required
            />
          </div>

          <button type="submit" class="submit-btn" :loading="registerLoading" :disabled="registerLoading">
            {{ registerLoading ? '注册中...' : '注册' }}
          </button>
        </form>

        <div class="switch-form">
          <span>已有账号？</span>
          <a href="#" @click.prevent="toggleForm">立即登录</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import { ElMessage } from 'element-plus';

export default {
  name: 'UserLogin',
  mounted() {
    // 每次进入登录页，清除旧的认证信息
    this.clearAuthData()
  },
  data() {
    return {
      isLogin: true,
      countdown: 0,
      loginLoading: false,
      registerLoading: false,
      loginForm: {
        phone: '',
        password: ''
      },
      registerForm: {
        phone: '',
        code: '',
        password: '',
        confirmPassword: ''
      }
    }
  },
  methods: {
    clearAuthData() {
      localStorage.removeItem('access_token')
      localStorage.removeItem('refresh_token')
      // 如果有其他认证相关的数据，也一并清除
      sessionStorage.clear()
    },
    toggleForm() {
      this.isLogin = !this.isLogin
      this.resetForms()
    },

    resetForms() {
      this.loginForm = { phone: '', code: '' }
      this.registerForm = { phone: '', code: '', password: '', confirmPassword: '' }
      this.countdown = 0
    },

    validatePhone(phone) {
      return /^1[3-9]\d{9}$/.test(phone)
    },

    async sendCode(type) {
      const form = type === 'login' ? this.loginForm : this.registerForm

      if (!this.validatePhone(form.phone)) {
        ElMessage.info('请输入正确的手机号')
        return
      }

      try {
        // TODO: 调用发送验证码API
        const res = await request.post('/sms/send?phone='+form.phone)
        if (res.code === 200) {
          ElMessage.success(res.message)
          // console.log('任务提交成功:', result)
        }else{
          ElMessage.error(res.message || '验证码发送失败')
        }

        // 模拟发送成功，开始倒计时
        this.countdown = 60
        const timer = setInterval(() => {
          this.countdown--
          if (this.countdown <= 0) {
            clearInterval(timer)
          }
        }, 1000)

      } catch (error) {
        ElMessage.error('发送失败，请稍后重试')
      }
    },

    async handleLogin() {
      if (!this.validatePhone(this.loginForm.phone)) {
        ElMessage.info('请输入正确的手机号')
        return
      }

      if (!this.loginForm.password) {
        ElMessage.info('请输入密码')
        return
      }
      this.loginLoading = true
      try {
        // TODO: 调用登录API
        const res = await request.post('/auth/login', this.loginForm)
        if(res.code === 200){
          localStorage.setItem('token', res.data.access_token)
          this.$router.push('/home')
        }else{
          ElMessage.error(res.message)
        }


      } catch (error) {
        ElMessage.error('登录失败');
      } finally {
        this.loginLoading = false
      }
    },

    async handleRegister() {
      if (!this.validatePhone(this.registerForm.phone)) {
        ElMessage.info('请输入正确的手机号')
        return
      }

      if (!this.registerForm.code) {
        ElMessage.info('请输入验证码')
        return
      }

      if (this.registerForm.password.length < 6) {
        ElMessage.info('密码长度不能少于6位')
        return
      }

      if (this.registerForm.password !== this.registerForm.confirmPassword) {
        ElMessage.info('两次输入的密码不一致')
        return
      }

      this.registerLoading = true
      try {
        // TODO: 调用注册API

        const res = await request.post('/regist/regist',
            this.registerForm)

        if (res.code === 200){
          ElMessage.success(res.message)
          this.toggleForm()
        }else{
          ElMessage.error(res.message)
        }

      } catch (error) {
        ElMessage.error('注册失败，请稍后重试');
      } finally {
        this.registerLoading = false
      }
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.login-container {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #ffeef8 0%, #ffd6e7 50%, #ffc4dd 100%);
  padding: 20px;
}

.login-box {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 30px;
  padding: 40px;
  width: 100%;
  max-width: 420px;
  box-shadow: 0 20px 60px rgba(255, 182, 193, 0.4);
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 182, 193, 0.3);
}

.logo-section {
  text-align: center;
  margin-bottom: 30px;
}

.app-title {
  font-size: 32px;
  color: #ff6b9d;
  margin-bottom: 10px;
  font-weight: bold;
  text-shadow: 2px 2px 4px rgba(255, 107, 157, 0.2);
}

.app-subtitle {
  color: #ff8fab;
  font-size: 14px;
}

.form-section {
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.form-title {
  text-align: center;
  color: #ff6b9d;
  margin-bottom: 25px;
  font-size: 24px;
  font-weight: 600;
}

.input-group {
  margin-bottom: 20px;
}

.input-group label {
  display: block;
  color: #ff8fab;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
}

.input-group input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #ffd6e7;
  border-radius: 12px;
  font-size: 14px;
  transition: all 0.3s ease;
  background: #fff5f8;
  color: #ff6b9d;
}

.input-group input::placeholder {
  color: #ffb3c6;
}

.input-group input:focus {
  outline: none;
  border-color: #ff6b9d;
  background: #fff;
  box-shadow: 0 0 0 4px rgba(255, 107, 157, 0.1);
}

.code-input-wrapper {
  display: flex;
  gap: 10px;
}

.code-input-wrapper input {
  flex: 1;
}

.send-code-btn {
  padding: 12px 16px;
  background: linear-gradient(135deg, #ffb3c6 0%, #ff8fab 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  font-weight: 500;
}

.send-code-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #ff8fab 0%, #ff6b9d 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 107, 157, 0.3);
}

.send-code-btn:disabled {
  background: #ffd6e7;
  cursor: not-allowed;
  opacity: 0.6;
}

.submit-btn {
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, #ff6b9d 0%, #ff8fab 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 10px;
  box-shadow: 0 4px 15px rgba(255, 107, 157, 0.3);
}

.submit-btn:hover {
  background: linear-gradient(135deg, #ff5a8f 0%, #ff6b9d 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 107, 157, 0.4);
}

.submit-btn:active {
  transform: translateY(0);
}

.switch-form {
  text-align: center;
  margin-top: 20px;
  color: #ff8fab;
  font-size: 14px;
}

.switch-form a {
  color: #ff6b9d;
  text-decoration: none;
  margin-left: 5px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.switch-form a:hover {
  color: #ff5a8f;
  text-decoration: underline;
}

@media (max-width: 480px) {
  .login-box {
    padding: 30px 20px;
  }

  .app-title {
    font-size: 28px;
  }

  .form-title {
    font-size: 20px;
  }

  .submit-btn:disabled {
    background: linear-gradient(135deg, #ffb3c6 0%, #ffd6e7 100%);
    cursor: not-allowed;
    opacity: 0.8;
    transform: none;
    box-shadow: none;
  }
}
</style>